<template>
  <div class="toufang-container">
    <el-container>
      <!-- 左侧表单区域 -->
      <el-aside
          :width="isFormVisible ? '500px' : '0'"
          class="form-sidebar"
          :class="{ 'form-hidden': !isFormVisible }">

        <div class="sidebar-toggle" @click="toggleForm">
          <i :class="isFormVisible ? 'el-icon-arrow-left' : 'el-icon-arrow-right'"></i>
        </div>
        <div class="rule-config-form" v-show="isFormVisible">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>{{ form.id ? '编辑规则配置' : '添加规则配置' }}</span>
            </div>

            <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px">

              <!-- 游戏ID -->
              <el-form-item label="游戏ID" prop="gameId">
                <el-select v-model="form.gameId" placeholder="请选择游戏ID" @change="queryGame(form.gameId)" style="width: 100%" clearable filterable>
                  <el-option
                      v-for="item in options"
                      :key="item.game_appid"
                      :label="item.game_name"
                      :value="item.game_appid">
                  </el-option>
                </el-select>

              </el-form-item>
              <!-- 项目ID -->
              <el-form-item label="项目ID" prop="projectId">
                <el-input v-model="form.projectId" placeholder="请输入项目ID"></el-input>
              </el-form-item>

              <!-- 投放平台 -->
              <el-form-item label="投放平台" prop="tfPaltform">
                <el-select v-model="form.tfPaltform" placeholder="请选择投放平台" style="width: 100%">
                  <el-option label="巨量" value="巨量投放"></el-option>
                  <el-option label="sigmob" value="sigmob"></el-option>
                </el-select>
              </el-form-item>

              <!-- 限制小时 -->
              <el-form-item label="限制小时" prop="limitHour">
                <el-input-number v-model="form.limitHour" :min="0" :max="24" placeholder="请输入限制小时数" style="width: 100%"></el-input-number>
              </el-form-item>
              <!-- 字段名 -->
              <el-form-item label="字段名" prop="fieldName">
                <el-select v-model="form.fieldName" placeholder="请选择字段名" style="width: 100%">
                  <el-option label="ecpm总值" value="TOTAL_VALUE"></el-option>
                  <el-option label="ecpm平均值" value="AVERAGE_VALUE"></el-option>
                  <el-option label="视频次数" value="VIDEO_COUNT"></el-option>
                  <el-option label="关卡" value="LEVEL"></el-option>
                </el-select>
              </el-form-item>

              <!-- 操作符 -->
              <el-form-item label="操作符" prop="operator">
                <el-select v-model="form.operator" placeholder="请选择操作符" style="width: 100%">
                  <el-option label="大于" value=">"></el-option>
                  <el-option label="小于" value="<"></el-option>
                  <el-option label="大于等于" value=">="></el-option>
                  <el-option label="小于等于" value="<="></el-option>
                  <el-option label="等于" value="="></el-option>
                  <el-option label="不等于" value="!="></el-option>
                </el-select>
              </el-form-item>

              <!-- 阈值 -->
              <el-form-item label="阈值" prop="threshold">
                <el-input-number v-model="form.threshold" :precision="2" :step="0.1" style="width: 100%"></el-input-number>
              </el-form-item>

              <!-- 逻辑操作符 -->
              <el-form-item label="逻辑操作符" prop="logicOperator">
                <el-select v-model="form.logicOperator" placeholder="请选择逻辑操作符"  style="width: 100%">
                  <el-option label="与" value="AND"></el-option>
                  <el-option label="或" value="OR"></el-option>
                </el-select>
              </el-form-item>

              <!-- 优先级 -->
              <el-form-item label="优先级" prop="priority">
                <el-input-number v-model="form.priority" :min="0" :max="999"></el-input-number>
              </el-form-item>



              <!-- 是否启用 -->
              <el-form-item label="是否启用" prop="isActive">
                <el-switch v-model="form.isActive" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
              </el-form-item>

              <!-- 数据库表状态 -->
              <el-form-item label="数据库表状态">
                <div class="db-status">
                  <el-tag :type="dbTableStatus ? 'success' : 'danger'">
                    {{ dbTableStatus ? '存在' : '不存在' }}
                  </el-tag>
                  <el-button
                      size="mini"
                      type="info"
                      plain
                      @click="getDataBase(form.gameId)"
                        style="margin-left: 10px;">
                    检查状态
                  </el-button>
                </div>
              </el-form-item>
              <!-- 操作按钮 -->
              <el-form-item class="form-actions">
                <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
                <el-button @click="resetForm('ruleForm')">重置</el-button>
              </el-form-item>
            </el-form>
          </el-card>
        </div>
      </el-aside>

      <!-- 右侧内容区域 -->
      <el-main class="main-content">
        <!-- 规则配置列表 -->
        <div class="rule-list-section">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>按游戏ID查询规则配置</span>
            </div>

            <!-- 游戏ID搜索 -->
            <el-form :inline="true" :model="searchForm" class="search-form">
              <el-select
                  v-model="valueAppid"
                  clearable
                  placeholder="请选择游戏"
                  size="small"
                  filterable
                  @change="search"
                  class="game-select">
                <el-option
                    v-for="item in options"
                    :key="item.game_appid"
                    :label="item.game_name"
                    :value="item.game_appid">
                </el-option>
              </el-select>
              <el-form-item>
                <el-button type="primary" @click="searchRules" size="mini" :loading="loading">查询</el-button>
                <el-button @click="toggleForm" size="mini" style="margin-left: 10px;">
                  {{ isFormVisible ? '隐藏添加表单' : '显示添加表单' }}
                </el-button>
              </el-form-item>
            </el-form>

            <!-- 规则配置列表 -->
            <el-table :data="ruleList" v-loading="loading" style="width: 100%" border size="mini">

              <el-table-column prop="gameId" label="游戏ID">
                <template slot-scope="scope">
                  <span>{{ getGameName(scope.row.gameId) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="gameId" label="游戏ID" ></el-table-column>
              <el-table-column prop="projectId" label="项目ID" >
                <template slot-scope="scope">
                  <span v-if="scope.row.projectId === ''">通用</span>
                  <span v-else>{{ scope.row.projectId }}</span>
                </template>

              </el-table-column>

<!--              <el-table-column prop="id" label="ID" width="80"></el-table-column>-->
<!--              <el-table-column prop="ruleType" label="规则类型" width="120"></el-table-column>-->
              <el-table-column label="字段名" width="150">
                <template slot-scope="scope">
                  <span v-if="scope.row.fieldName === 'TOTAL_VALUE'">ecpm总和</span>
                  <span v-else-if="scope.row.fieldName === 'AVERAGE_VALUE'">ecpm平均值</span>
                  <span v-else-if="scope.row.fieldName === 'VIDEO_COUNT'">视频次数</span>
                  <span v-else-if="scope.row.fieldName === 'LEVEL'">关卡</span>
                  <span v-else>{{ scope.row.fieldName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="operator" label="操作符" width="100"></el-table-column>
              <el-table-column prop="threshold" label="阈值" width="100"></el-table-column>
              <el-table-column prop="priority" label="优先级" width="80"></el-table-column>
              <el-table-column prop="logicOperator" label="与下一条件关系"></el-table-column>

              <el-table-column prop="tfPaltform" label="投放平台" width="120">

              </el-table-column>

              <el-table-column prop="limitHour" label="有效小时" width="100"></el-table-column>
              <el-table-column label="是否启用" width="100">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.isActive ? 'success' : 'danger'">
                    {{ scope.row.isActive ? '启用' : '禁用' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作"  width="150">
                <template slot-scope="scope">
                  <el-button size="mini" @click="editRule(scope.row)">编辑</el-button>
                  <el-button size="mini" type="danger" @click="deleteRule(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>

            <!-- 分页 -->
            <el-pagination
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-size="18"
                layout="total, prev, pager, next, jumper"
                :total="total"
                class="pagination-bar">
            </el-pagination>
          </el-card>
        </div>

        <!-- 用户价值列表 -->
        <div class="user-value-section">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>用户价值管理</span>
            </div>

            <div class="filter-controls">
              <el-date-picker
                  size="mini"
                  v-model="valueRegister"
                  @change="fetchProjectList(valueRegister,gameName)"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  class="date-picker">
              </el-date-picker>

              <el-select v-model="valueAppid"     @change="handleGameChange" clearable placeholder="请选择游戏" size="mini" filterable class="game-select">
                <el-option
                    v-for="item in options"

                    :key="item.game_appid"
                    :label="item.game_name"
                    :value="item.game_appid">
                </el-option>
              </el-select>

              <el-select
                  v-model="project_Id"
                  clearable
                  placeholder="请选择项目"
                  size="mini"
                  filterable
                  class="project-input"
                >
                <el-option
                    v-for="item in projectOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>

              <!-- 添加排序开关 -->
              <el-switch
                  v-model="orderEcpm"
                  active-text="按ECPM排序"
                  inactive-text="日期排序"
                  size="mini"      style="margin-right: 10px;">
              </el-switch>
              <el-button size="mini" @click="searchV" type="primary">刷新</el-button>
            </div>

            <el-table
                :data="tableDataValue"
                stripe                style="margin-top: 15px;"
                size="mini"
                :header-cell-style="{background:'#f85252',height:'40px',color:'#ffffff'}"
                :default-sort="{prop: 'date', order: 'descending'}"
                :key="randomKey"
                class="user-value-table">
              <el-table-column
                  align="center"

                  prop="registerDate"
                  label="注册日期">
                <template slot-scope="scope">
                  {{ formatDate(scope.row.registerDate) }}
                </template>
              </el-table-column>
              <el-table-column
                  align="center"

                  prop="openid"
                  label="openid">
              </el-table-column>
              <el-table-column
                  align="center"
                  fixed
                  prop="projectId"
                  label="项目id">
              </el-table-column>
              <el-table-column
                  align="center"

                  prop="sumValue"
                  label="用户累计价值">
              </el-table-column>

              <el-table-column
                  align="center"

                  prop="value"
                  label="用户价值">
              </el-table-column>

              <el-table-column
                  align="center"

                  prop="userValue"
                  label="操作">
                <template slot-scope="scope">
                  <div v-if="!scope.row.callbck">
                    <el-popconfirm
                        confirm-button-text='好的'
                        cancel-button-text='不用了'
                        icon="el-icon-info"
                        icon-color="red"
                        title="确定回传该用户吗？"
                        @confirm="callbackwx(scope.row)">
                      <el-button slot="reference" size="mini" style="height: 25px" type="primary">回传</el-button>
                    </el-popconfirm>
                  </div>
                  <div v-else>已回传</div>
                </template>
              </el-table-column>
            </el-table>

            <div class="pagination-wrapper">
              <el-pagination
                  :current-page.sync="currentPageValue"
                  @current-change="searchV"
                  layout="prev, pager, next"
                  background
                  :page-size="20"
                  :total="1500"
                  class="user-value-pagination">
              </el-pagination>
            </div>
          </el-card>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import en from "element-ui/src/locale/lang/en";

export default {
  name: "TouFang",
  computed: {
    en() {
      return en
    },

  },
  //数据
  data() {
    return {
      gameName:'',
      project_Id: '', // 保持现有定义
      projectOptions: [], // 新增：项目选项数据
      dbTableStatus: null,
      tableDataValue:[],
          isFormVisible: false,
      options: [],
      searchForm: {
        gameId: ''
      }, // ... 其他规则
      logicOperator: [
        { required: true, message: '请选择逻辑操作符', trigger: 'change' }
      ],
      ruleList: [],
      currentPage: 1,
      total: 0,
      valueDate: '',
      radioType: '1',
      currentPageValue:1,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },

      tableData: null,
      valueAppid: '',
      talbeDataDyRecord2: [],
      talbeDataDyRecord3: [],
      currentPage7: 1,
      num: 5,
      downDate: "",
      value2: '',
      radio2: '5',
      valueRegister: new Date().toISOString().split('T')[0],
      callback: '',
      event: '1',
      orderEcpm: true,
      formLabelWidth: '100px',
      loading: false, form: {
        id: null,
        ruleType: 'userValue',
        fieldName: '',
        operator: '',
        threshold: 0,
        logicOperator: '',
        priority: 0,
        isActive: true,
        projectId: '',
        gameId: null,
        tfPaltform: '',  // 新增：投放平台
        limitHour: 0     // 新增：限制小时
      },
      rules: {
        ruleType: [
          { required: true, message: '请选择规则类型', trigger: 'change' }
        ],
        fieldName: [
          { required: true, message: '请选择字段名', trigger: 'change' }
        ],
        operator: [
          { required: true, message: '请选择操作符', trigger: 'change' }
        ],
        threshold: [
          { required: true, message: '请输入阈值', trigger: 'blur' }
        ],
        tfPaltform: [
          { required: true, message: '请选择投放平台', trigger: 'change' }
        ],
        limitHour: [
          { required: true, message: '请输入限制小时', trigger: 'blur' },
          { type: 'number', min: 0, max: 24, message: '限制小时必须在0-24之间', trigger: 'blur' }
        ]
      }



    }
  }, mounted: function () {


    this.searchRules()

    this.findAllGame()
    // this.fetchProjectList();
  },
  methods: {

    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    handleGameChange(gameId) {
      console.log(gameId)
      // 当游戏改变时，获取项目列表，传入当前选中的游戏名称
      const selectedGame = this.options.find(item => item.game_appid === gameId);
      this.gameName = selectedGame ? selectedGame.game_name : '';

      if (this.valueRegister) {
        this.fetchProjectList(this.valueRegister, this.gameName);
      } else {
        // 如果没有选择日期，使用当前日期
        this.fetchProjectList(new Date().toISOString().split('T')[0], this.gameName);
      }

    },
    fetchProjectList(date, name = '') {
      // 如果没有传入日期，则使用当前日期
      if (!date) {
        date = new Date().toISOString().split('T')[0];
      }
      if(name===''||name===null)
        return

      this.$axios
          .get(`https://dy.darknight.games/juliang/getProject`, {
            params: {
              date: date,
              name: name
            },
            withCredentials: false
          })
          .then(response => {
            if (response.data.code === 0) {
              this.projectOptions = response.data.data.list.map(item => ({
                value: item.project_id,
                label: `${item.project_id} [消耗: ${item.metrics.stat_cost}][转化: ${item.metrics.convert_cnt}][ ${item.project_name}]`
              }));

              this.$message.success('获取项目列表成功');
            } else {
              this.$message.error('获取项目列表失败');
              this.projectOptions = [];
            }
          })
          .catch(error => {
            console.error('获取项目列表错误:', error);
            this.$message.error('获取项目列表失败: ' + error.message);
            this.projectOptions = [];
          });
    },
    getDataBase(gameName) {


      this.$axios
          .get('https://ks.darknight.games/callbackApi/api/gameConfig/get', {withCredentials: false

          })
          .then(successResponse => {
            if (successResponse.status === 200) {

              const apiData = successResponse.data.data;

              const matchingKey = Object.keys(apiData).find(key => key === gameName);

              if (matchingKey) {

                this.dbTableStatus=true

              }else{
                this.dbTableStatus=false
              }

              console.log("data",this.tableData)
            } else {
              this.$router.replace({path: '/error'})
              console.log("错误")

            }
          })


    },
    queryGame(gameName){


      this.getDataBase(gameName)

    },
    getGameName(gameId) {
      if (!gameId) return '';
      const game = this.options.find(item => item.game_appid === gameId);
      return game ? game.game_name : gameId;
    },
    searchRules() {

      this.currentPage = 1;
      this.fetchRules();
    },

    // 获取规则配置列表
    fetchRules() {
      this.loading = true;

      if(this.valueAppid===''){

        this.$http.get(`https://ks.darknight.games/ruleConfig/findAll/${this.currentPage}`,{withCredentials:false})
            .then(response => {
              const data = response.data;

              console.log("====================")
              this.ruleList = data[0].records;
              this.total = data[0].total;

            })
            .catch(error => {
              this.$message.error('查询失败: ' + error.message);
            })
            .finally(() => {
              this.loading = false;
            });
      }else{
        this.$http.get(`https://ks.darknight.games/ruleConfig/findByGameId/${this.valueAppid}/${this.currentPage}`)
            .then(response => {
              const data = response.data;

              console.log("====================")
              this.ruleList = data[0].records;
              this.total = data[0].total;

            })
            .catch(error => {
              this.$message.error('查询失败: ' + error.message);
            })
            .finally(() => {
              this.loading = false;
            });
      }


    },
    toggleForm() {
      this.isFormVisible = !this.isFormVisible;
    },
    // 分页切换
    handleCurrentChange(val) {
      this.currentPage = val;
      if (this.valueAppid) {
        this.fetchRules();
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid && this.dbTableStatus) {

          this.saveRuleConfig();
        } else {
          this.$message({
            message: '请填写完整表单或者添加数据库表',
            type: 'warning'
          });
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    goBack() {
      this.$router.go(-1);
    },
    saveRuleConfig() {
      this.$http.post('https://ks.darknight.games/ruleConfig/save', this.form)
          .then(response => {
            const data = response.data;
            if (data.code === 200) {
              this.$message({
                message: data.message,
                type: 'success'
              });
              this.searchRules()
              // this.$router.go(-1);
            } else {
              this.$message({
                message: data.message || '保存失败',
                type: 'error'
              });
            }
          })
          .catch(error => {
            this.$message({
              message: '保存失败: ' + error.message,
              type: 'error'
            });
          });
    },

    callbackwx(row){

      this.axios
          .get('https://ks.darknight.games/callbackApi/api/callbackWx/'+row.openid+'/'+this.valueAppid,  { withCredentials: false })
          .then(successResponse => {

            if (successResponse.status === 200) {


              this.$message.success('成功')
            }
          })

    },

    searchV(){

      this.axios
          .get('https://ks.darknight.games/callbackApi/api/getUserValue3/'+this.valueRegister+'/'+this.valueAppid+'?projectId='+this.project_Id+'&pageNum='+this.currentPageValue+"&pageSize=15&orderEcpm="+this.orderEcpm,  { withCredentials: false })
          .then(successResponse => {

            if (successResponse.status === 200) {

              this.tableDataValue = successResponse.data.data.list
            }
          })

    }
    , createExportData() {


      return this.talbeDataDyRecord3

    },

    tableRowClassName({row, rowIndex}) {
      // console.log(row)
      if (rowIndex % 2 == 1) {
        return 'warning-row';
      } else if (rowIndex % 2 == 0) {
        return 'success-row';
      }
      return '';
    },  // 编辑规则
    editRule(row) {
      // 将选中行的数据赋值给表单
      this.form = {
        id: row.id,
        gameId: row.gameId,
        projectId: row.projectId,
        fieldName: row.fieldName,
        operator: row.operator,
        threshold: row.threshold,
        logicOperator: row.logicOperator,
        priority: row.priority,
        isActive: row.isActive,
        tfPaltform: row.tfPaltform || '',  // 新增：投放平台
        limitHour: row.limitHour || 0      // 新增：限制小时
      };
      // 显示表单
      this.isFormVisible = true;
    }
   ,

    // 删除规则
    deleteRule(row) {
      this.$confirm('确定要删除该规则配置吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.get(`https://ks.darknight.games/ruleConfig/delete/${row.id}`)
            .then(response => {
              const data = response.data;
              if (data.code === 200) {
                this.$message.success('删除成功');
                this.fetchRules(); // 重新加载数据
              } else {
                this.$message.error(data.message || '删除失败');
              }
            })
            .catch(error => {
              this.$message.error('删除失败: ' + error.message);
            });
      });
    },
    search(val) {

      console.log(`当前页: ${val}`);
      // console.log(this.value2);
      this.$axios
          .get('https://ks.darknight.games/ruleConfig/findAll/' + this.currentPage, {})

          .then(successResponse => {

            if (successResponse.status === 200) {

              this.tableData = successResponse.data

              console.log(successResponse.data)

            } else {
              this.$router.replace({path: '/error'})
              console.log("错误")

            }
          })



    }, findAllGame() {


      this.$axios
          .post('https://chengmei.games:4443/api/data/findGameInfo', {})
          .then(successResponse => {
            if (successResponse.status === 200) {

              this.options = successResponse.data.data.filter(item=>
              !item.game_name.includes('('))

            } else {
              this.$router.replace({path: '/error'})
              console.log("错误")

            }
          })

    }




  }

}
</script>

<style>

.el-row {
  margin-bottom: 20px;

}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

</style>

<style scoped>
.toufang-container {
  background-image: url('https://p3-oe-bp.byteimg.com/tos-cn-i-0aqtudv0qh/dce7327a565c523523d8ac2b8a43b316.png~tplv-0aqtudv0qh-image.image');
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  height: 100vh;
  overflow: hidden;
  padding: 20px;
  box-sizing: border-box;
}

/* 布局样式 */
.el-container {
  height: 100%;
  display: flex;
}

.form-sidebar {
  position: relative;
  transition: width 0.3s ease;
  padding: 20px 10px 20px 20px;
  overflow: hidden;
  flex-shrink: 0;
}

.form-sidebar.form-hidden {
  padding: 0;
}

.sidebar-toggle {
  position: absolute;
  top: 50%;
  right: -20px;
  transform: translateY(-50%);
  width: 20px;
  height: 60px;
  background: #409EFF;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  z-index: 100;
  box-shadow: 2px 0 5px rgba(0,0,0,0.1);
}

.sidebar-toggle:hover {
  background: #66b1ff;
}

.rule-config-form {
  height: 100%;
  overflow-y: auto;
}

.main-content {
  padding: 0 20px 0 10px;
  overflow-y: auto;
  flex: 1;
}

/* 表单区域样式 */
.rule-config-form .box-card {
  max-width: 100%;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

/* 列表区域样式 */
.rule-list-section,
.user-value-section {
  margin-bottom: 20px;
}

.search-form {
  margin-bottom: 20px;
}

.game-select {
  width: 180px;
  margin-right: 12px;
}

/* 用户价值区域样式 */
.filter-controls {
  display: flex;
  gap: 15px;
  align-items: center;
  flex-wrap: wrap;
}

.date-picker,
.project-input {
  margin-right: 10px;
  min-width: 300px
}

.user-value-table {
  margin-top: 15px;
  border: none;
}

.pagination-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.pagination-bar,
.user-value-pagination {
  text-align: center;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .el-aside {
    width: 100% !important;
  }

  .el-main {
    padding: 10px;
  }

  .filter-controls {
    flex-direction: column;
    align-items: flex-start;
  }

  .date-picker,
  .game-select,
  .project-input {
    margin-bottom: 10px;
    width: 100% !important;
  }
}
</style>


